import { getLink } from '../../../utils/utils';
import img from '../../images/aliflanke_img.jpg';
import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Estis nokto, tia mirinda nokto, kia povas okazi nur en nia juneco. 
      Dum tia nokto oni vidas belegajn sonĝojn. 
      Mi ŝatas sonĝi. 
      En sonĝoj ni vivas per alia vivo, nia animo translokiĝas al alia mondo, kaj tie ni travivas milojn da vivoj anstataŭ nur unu, pobra kaj strikte enkadrigita, per kiu ni vivas tage.
    </p>

    <p class="mb-3">
      De nia domo mi malsupreniĝis al maro. 
      Mi sciis, ie interne mi ĉiam sciis, ke se iri subdekliven kaj poste dekstren laŭ la bordo, oni tuj trovos malvastan strandon. 
      Tage ĝi ne videblas pro la domoj, ŝipoj, dokoj, - tamen ĝi estas, kaj nokte mi ofte descendas al ĝi laŭ la sunplena pado, - en miaj sonĝoj ĉiam hele brilas suno.
    </p>

    <p class="mb-3">
      Antaŭe mi ĉiam estis tie sola. 
      Sed hodiaŭ mi vidas, ke al la sabla bordo lante proksimiĝas boato. 
      La maro estas serena, ĝia surfaco apenaŭ sulkas sub ritmaj frapoj de remiloj. 
      La boato alflosis al la sablo kaj iu viro eliris surborden. 
      Mi neniam vidis lin antaŭe, sed tio ne gravas: mi neniam vidas en sonĝoj miajn konatojn. 
      En diversaj vivoj mi havas diversajn vizaĝojn, kaj ĉiam aliaj homoj estas proksimaj al mi. 
      Mi ne konis tiun homon, sed sciis, ke li venis por mi. 
      Li etendis al mi brakon kaj mi eniris en la boaton. 
      Ĉirkaŭe fariĝis pli obskure; sur griza maro sub griza firmamento la boato elanis foren.
    </p>

    <p class="mb-3">
      Kiam ni albordiĝis, estis jam tute mallume. 
      Mi ne discernis la konturojn de la urbo, vidis nur la altajn domojn kaj brilon de pavimŝtonoj. 
      Ni ekiris laŭ unu el stratoj, malplena kaj senhoma. 
      Kiam ni preterpasis iun pordon, ĝi malfermiĝis, kaj min ĉirkaŭis la kirlo de lumo kaj muziko: 
      brilantaj lustroj, nudaj virinaj ŝultroj, diamantoj, akra glimo de kupraj muzikiloj kaj pasia odoro de parfumoj.
    </p>

    <p class="mb-3">
      Ni rapide trairis la halon kaj laŭ la malvasta ŝtuparo supreniris kelkajn ŝtupseriojn. 
      En la malfermita antaŭ ni ĉambro, trankvila kaj silenta, aparte kontrasta de la brua balo malsupre, sur la malhela tapiŝo staris kelkaj foteloj, granda skribotablo – kaj nenio plu. 
      Pura freŝa aero plenigis la ĉambron.
    </p>

    <p class="mb-5">
      Mi eksidis en unu el foteloj kaj ekatendis.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3">
      La muro malfermiĝis antaŭ mi. 
      Tie, postmure, en la sama ĉambro estis mi. 
      Mi sciis, ke tio estas mi, kvankam nenion komunan povis trovi kun tiu obeza virinaĉo kun verdeska ŝvela vizaĝo. 
      Ne, mi ne volas! 
      Ne volas mi esti tia! 
      Ne volas!
    </p>

    <p class="mb-3">
      Aliaj bildoj alternis, kaj ili estis eĉ pli teruraj. 
      Jen ostoza sordida almozulino, kun batbluo ĉe okulo kaj hirtaj haroj, ion serĉas fosante en malfermita rubujo. 
      Jen abomena, krude ŝminkita kaj ebria, okulumas al preterpasantoj. 
      Jen – sur la lito en malsanulejo, kaj apude – iuj strangaj aparatoj… 
      Ne, ne, ne!!!
    </p>

    <p class="mb-3"> 
      Jen bela virino kun brilaj okuloj. 
      Sed ankaŭ ŝi malaperas; malaperas same, kiel tiuj aliaj. 
      Jen dika gaja oldulino, jen magra kolera oldulino; tamen la okuloj ne brilas ĉe ambaŭ. 
      Kial la bona fino ests nur unusola?? 
      Mi NE DEZIRAS tian estonton!
    </p>

    <p class="mb-3">
      Kaj mi denove trovis min en la boato naviganta tra la griza maro, kune kun mia silenta akompananto. 
      Jam la bordo videblas… 
      Ni albordiĝas - sed tio estas la bordo de tute alia lando. 
      Mi havas alian vizaĝon, kaj antaŭ mi kuŝas alia vivo kaj alia estonto. 
      Kiam mi vekiĝos…
    </p>
    
    <p class="mb-3">
      Ĉar nun estas nokto. 
      La nokto, kiam la mondo ŝanĝiĝas. 
      Tiel mirinda nokto, tia nokto, kia povas okazi nur en nia juneco.
    </p>
    
    <img src=${img} />
    `
  )
}

const itemName = {
  esp: 'Aliflanke de maro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;